// extracted by mini-css-extract-plugin
export default {"success_page":"Success_success_page__+JQn7","success_message":"Success_success_message__YRcos","congrats":"Success_congrats__KTaNU","all_done":"Success_all_done__dIwkm"};